var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#F7F6F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8120_1821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7114 39.2168V47.6654H54.2892V41.521",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2892 29.2317V18.4789L48.1448 12.3345H29.7114V26.9275",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.145 12.3345V18.4789H54.2895L48.145 12.3345Z",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5941 30L47.3774 39.2167L45.8413 43.825L50.4496 42.2889L59.6663 33.0722L56.5941 30Z",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.521 33.0723L56.5932 36.1445",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3354 30.7685L33.5521 39.9852L38.1605 41.5213L36.6243 36.913L27.4077 27.6963L24.3354 30.7685Z",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4077 33.8398L30.4799 30.7676",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4638 22.3203H33.5513",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4491 22.3203H42.0005",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1596 26.1597H33.5513",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4486 26.1592H39.6958",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.304 30H33.5513",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4496 30H45.8413",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2338 33.8408H36.6255",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6806 33.8408H42.7681",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8407 37.6807H38.9282",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0727 18.4795H38.9282",
    stroke: "#0D4248",
    strokeWidth: 1.31667,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8120_1821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.8667,
    height: 36.8667,
    fill: "white",
    transform: "translate(23.5669 11.5669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyIcon);
export default __webpack_public_path__ + "static/media/policy-icon.88988f4341cb35b515eed4ae671b790b.svg";
export { ForwardRef as ReactComponent };